
import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

const stats = [
  { number: '4,000kg', label: 'Yuga-1 Payload Capacity', icon: 'ri-rocket-line' },
  { number: '5+', label: 'Advanced Engine Designs', icon: 'ri-fire-line' },
  { number: '2024+', label: 'Mission Ready Timeline', icon: 'ri-calendar-line' },
  { number: 'AI-Powered', label: 'Smart Propulsion Systems', icon: 'ri-brain-line' }
];

export default function HeroSection() {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate('/technology');
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/a02e7d4977ccc4b9a8bc14c040a4099e.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
      
      {/* Animated Stars */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${Math.random() * 2 + 2}s`
            }}
          />
        ))}
      </div>

      <div className="relative z-10 container mx-auto px-6">
        <div className="max-w-4xl">
          <div className="mb-8">
            <div className="inline-flex items-center space-x-2 bg-blue-600/20 backdrop-blur-sm border border-blue-400/30 rounded-full px-4 py-2 mb-6">
              <i className="ri-rocket-line text-blue-400"></i>
              <span className="text-blue-300 text-sm font-medium">Advanced Aerospace & Defence Technology</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Transforming{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
                India's Space
              </span>{' '}
              Capabilities
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl">
              Developing scalable, intelligent, and high-performance aerospace technologies. 
              From heavy-lift launch vehicles to AI-powered satellites, we're positioning India 
              as a global leader in space and defence innovation.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              variant="primary" 
              size="lg" 
              className="group cursor-pointer"
              onClick={handleExploreClick}
            >
              <span>Explore Our Technology</span>
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">4,000kg</div>
              <div className="text-gray-400 text-sm">Yuga-1 Payload Capacity</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">2024</div>
              <div className="text-gray-400 text-sm">Founded in Pune</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">IN-SPACe</div>
              <div className="text-gray-400 text-sm">Registered & Authorized</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">7+</div>
              <div className="text-gray-400 text-sm">Core Applications</div>
            </div>
          </div>

        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-white text-sm">Discover our mission</span>
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </div>
      </div>
    </section>
  );
}
